import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import styled from "styled-components";

import { SimulationTab } from "./SimulationTab";

const ConsoleLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ConsoleCard = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 49, 0.05);
  padding: 32px;
`;

/**
 * The superuser Intelligent Grouping Simulation tool, cloned in
 * structure from EdnitionAdmin / SessionSummaryPromptConsole (react-bootstrap
 * Tabs/Tab). A SINGLE "Simulation" tab for v1. Every backend
 * call goes through request() from useOkoApi (Firebase bearer auto-attached).
 * Access is enforced by the superuser-guarded endpoints, not by a menu boolean.
 */
export const GroupingSimulationConsole = () => {
  const [activeTab, setActiveTab] = useState("simulation");

  return (
    <ConsoleLayout className="grouping-simulation-console">
      <ConsoleCard>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="simulation" title="Simulation">
            <SimulationTab />
          </Tab>
        </Tabs>
      </ConsoleCard>
    </ConsoleLayout>
  );
};
